import React, { useState } from 'react';
import {OpenSheetMusicDisplay} from 'opensheetmusicdisplay';
import {Fraction} from 'opensheetmusicdisplay';
import {Pitch} from 'opensheetmusicdisplay';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import settingSystem from 'SettingSystem';

import SheetMusicPlayer from "./SheetMusicPlayer.js"

const INPUT_POSITION_OFFSET = 10;
const DISPLAY_POSITION_OFFSET = 10;
const HOLD_TIME = 250; // ms


export default class ScoreRangeSelector extends React.Component {
	
	state = {
		visible: false,

		startPosition: 0,
		endPosition: 0,

		startMeasure: null,
		endMeasure: null,

		startTimestamp: 0,
		endTimestamp: 0,
	};
	
	holdTimer = null;
	scrollBox = this.props.scrollBox;

	scrollInterval = null;
	scrollDirection = null;
	
	draggingHandle = null;

	initialize(e) {
		this.setPositionByMouseEvent(e);
	}

	updatePositionByTimestamps() {
		const osmd = this.props.osmd;
		const osmdExtension = this.props.osmdExtension;

		const startVerticalItemInfo = osmdExtension.getVerticalItemInfoByTimestamp(this.state.startTimestamp);
		const endVerticalItemInfo = osmdExtension.getVerticalItemInfoByTimestamp(this.state.endTimestamp);

		let startPosition = this.state.startPosition;
		let endPosition = this.state.endPosition;

		if (startVerticalItemInfo) {
			if (!startVerticalItemInfo.isTheLastBeam) { // disallow setting the left position to the end of a music system
				if (startVerticalItemInfo.isFirstItemInTheMeasure) { // snap the position to the beginning of a bar
					startPosition = osmdExtension.osmd2ActualPosition(
						osmd.graphic.measureList[startVerticalItemInfo.measureId][0].boundingBox.absolutePosition.x
					);
				} else {
					startPosition = osmdExtension.osmd2ActualPosition(startVerticalItemInfo.x) - DISPLAY_POSITION_OFFSET;
				}
			}
			
		}
		
		if (endVerticalItemInfo) { // disallow setting the right position to the beginning of a music system
			if (endVerticalItemInfo.isFirstItemInTheMeasure) {

				if (endVerticalItemInfo.isFirstItemInTheMusicSystem && endVerticalItemInfo.measureId > 0) { // snap to the end of the upper music system
					const prevMeasure = osmd.graphic.measureList[endVerticalItemInfo.measureId-1][0];
					
					endPosition = osmdExtension.osmd2ActualPosition(
						prevMeasure.boundingBox.absolutePosition.x
						+ prevMeasure.boundingBox.boundingRectangle.x
						+ prevMeasure.boundingBox.boundingRectangle.width
					);

				} else { // snap the position to the beginning of a bar
					endPosition = osmdExtension.osmd2ActualPosition(
						osmd.graphic.measureList[endVerticalItemInfo.measureId][0].boundingBox.absolutePosition.x
					);
				}
			} else {
				if (endVerticalItemInfo.isTheLastBeam) {
					endPosition = osmdExtension.osmd2ActualPosition(endVerticalItemInfo.x);
				} else {
					endPosition = osmdExtension.osmd2ActualPosition(endVerticalItemInfo.x) - DISPLAY_POSITION_OFFSET;
				}
			}
		}

		// console.log(this.state.startTimestamp, this.state.endTimestamp);

		this.setState({
			startPosition: startPosition,
			endPosition: endPosition,
		});
	}
	
	setPositionByMouseEvent(e, leftFixed=false, rightFixed=false, yFallback=null) { // yFallback is in OSMD space
		const osmd = this.props.osmd;
		const osmdExtension = this.props.osmdExtension;
				
		const mouseOsmdPosition = {
			x: osmdExtension.actual2OsmdPosition(e.clientX + this.scrollBox.scrollLeft + INPUT_POSITION_OFFSET), 
			y: osmdExtension.actual2OsmdPosition(e.clientY + this.scrollBox.scrollTop)
		};
		
		let closestVerticalItemInfo = osmdExtension.getClosestVerticalItemInfo(
			mouseOsmdPosition.x, mouseOsmdPosition.y
		);
		
		// Try to use a fallback y position (pobably a position in the current music system)
		if (closestVerticalItemInfo == null) {
			closestVerticalItemInfo = osmdExtension.getClosestVerticalItemInfo(
				mouseOsmdPosition.x, yFallback
			);
		}
		
		if (closestVerticalItemInfo) {
			// console.log(closestVerticalItemInfo	);
			
			let startPosition = this.state.startPosition;
			let endPosition = this.state.endPosition;
			
			let startMeasure = this.state.startMeasure;
			let endMeasure = this.state.endMeasure;

			let startTimestamp = this.state.startTimestamp;
			let endTimestamp = this.state.endTimestamp;
			
			const closestMeasure = osmd.graphic.measureList[closestVerticalItemInfo.measureId];
			
			if (!leftFixed) {
				// if the vertical item is the last beam, change it to the last vertical item before the last beam in the music system (the idx of the last beam dummy item is the previous real vertical item)
				if (closestVerticalItemInfo.isTheLastBeam) {
					closestVerticalItemInfo = osmdExtension.verticalItemInfos[closestVerticalItemInfo.idx]
				}

				if (closestVerticalItemInfo.isFirstItemInTheMeasure) { // snap the position to the beginning of a bar
					startPosition = osmdExtension.osmd2ActualPosition(
						osmd.graphic.measureList[closestVerticalItemInfo.measureId][0].boundingBox.absolutePosition.x
					);
				} else {
					startPosition = osmdExtension.osmd2ActualPosition(closestVerticalItemInfo.x) - DISPLAY_POSITION_OFFSET;
				}
				
				startMeasure = closestMeasure;
				startTimestamp = closestVerticalItemInfo.timestamp;
				
			}
			
			if (!rightFixed) {
				if (!leftFixed) { // both left and right are not fixed, so this is a intialization
					
					endPosition = osmdExtension.osmd2ActualPosition(
						closestMeasure[0].boundingBox.absolutePosition.x +
						closestMeasure[0].boundingBox.boundingRectangle.x + 
						closestMeasure[0].boundingBox.boundingRectangle.width
					);

					endMeasure = closestMeasure;
					endTimestamp = Fraction.plus(closestMeasure[0].parentSourceMeasure.absoluteTimestamp, closestMeasure[0].parentSourceMeasure.duration)

				} else {
					if (!closestVerticalItemInfo.isFirstItemInTheMusicSystem) { // disallow setting the right position to the beginning of a music system
						if (!closestVerticalItemInfo.isTheLastBeam && closestVerticalItemInfo.isFirstItemInTheMeasure) { // snap the position to the beginning of a bar
							endPosition = osmdExtension.osmd2ActualPosition(
								osmd.graphic.measureList[closestVerticalItemInfo.measureId][0].boundingBox.absolutePosition.x
							);
						// } else if (closestVerticalItemInfo.isLastItemInTheMusicSystem) {
						// 	endPosition = osmdExtension.osmd2ActualPosition(
						// 		osmd.graphic.measureList[closestVerticalItemInfo.measureId][0].boundingBox.absolutePosition.x +
						// 		osmd.graphic.measureList[closestVerticalItemInfo.measureId][0].boundingBox.boundingRectangle.x +
						// 		osmd.graphic.measureList[closestVerticalItemInfo.measureId][0].boundingBox.boundingRectangle.width
						// 	);
							// console.log("B", endPosition);
						} else {
							if (closestVerticalItemInfo.isTheLastBeam) {
								
								endPosition = osmdExtension.osmd2ActualPosition(closestVerticalItemInfo.x);
							} else {
								endPosition = osmdExtension.osmd2ActualPosition(closestVerticalItemInfo.x) - DISPLAY_POSITION_OFFSET;
							}
						}

						endMeasure = closestMeasure;
						endTimestamp = closestVerticalItemInfo.timestamp;
					}
				}
			}
			
			// Prevent the right position is small than the left position
			if (!leftFixed && rightFixed) { // moving left position
				
				if (startMeasure[0].measureNumber > endMeasure[0].measureNumber || (startMeasure[0].measureNumber == endMeasure[0].measureNumber && startPosition >= endPosition)) {
					startPosition = this.state.startPosition;
					startMeasure = this.state.startMeasure;
					startTimestamp = this.state.startTimestamp;
				}
			}
			
			if (leftFixed && !rightFixed) { // moving right position
				
				if (startMeasure[0].measureNumber > endMeasure[0].measureNumber || (startMeasure[0].measureNumber == endMeasure[0].measureNumber && startPosition >= endPosition)) {
					endPosition = this.state.endPosition;
					endMeasure = this.state.endMeasure;
					endTimestamp = this.state.endTimestamp;
				}
			}

			// console.log(startTimestamp, endTimestamp);

			/////////////////////////////////////////
			
			this.setState({
				visible: true,
				startPosition: startPosition,
				endPosition: endPosition,
				startMeasure: startMeasure,
				endMeasure: endMeasure,
				startTimestamp: startTimestamp,
				endTimestamp: endTimestamp
			});

			settingSystem.setSetting("loopTimestamp", [startTimestamp, endTimestamp], this);
		}
	}

	close() {
		this.setState({visible: false})
		this.onClose();
	}

	onClose(){
		settingSystem.setSetting("loopTimestamp", null, this);
	}

	clearScrollInterval() {
		clearInterval(this.scrollInterval);
		this.scrollInterval = null;
		this.scrollDirection = null;
	}
	
	componentDidMount() {
		const osmd = this.props.osmd;
		const osmdExtension = this.props.osmdExtension;

		const handleDown = (e)=>{
			this.holdTimer = setTimeout(() => {
				this.initialize(e);
				
				const mouseOsmdPosition = {
					x: osmdExtension.actual2OsmdPosition(e.clientX + this.scrollBox.scrollLeft + INPUT_POSITION_OFFSET), 
					y: osmdExtension.actual2OsmdPosition(e.clientY + this.scrollBox.scrollTop)
				};
				
				let closestVerticalItemInfo = osmdExtension.getClosestVerticalItemInfo(mouseOsmdPosition.x, mouseOsmdPosition.y);
				if (closestVerticalItemInfo) {
					// if the vertical item is the last beam, change it to the last vertical item before the last beam in the music system (the idx of the last beam dummy item is the previous real vertical item)
					if (closestVerticalItemInfo.isTheLastBeam) {
						closestVerticalItemInfo = osmdExtension.verticalItemInfos[closestVerticalItemInfo.idx]
					}

					// this.props.setCursor(closestVerticalItemInfo)

					const targetTime = closestVerticalItemInfo.timestamp.realValue;
					SheetMusicPlayer.singleton.seekByTimestamp(targetTime);
					
				}
				
				this.holdTimer = null;
			}, HOLD_TIME);
		}

		const handleUp = (e)=>{
			clearTimeout(this.holdTimer);
			this.holdTimer = null;
			
			this.draggingHandle = null;

			this.clearScrollInterval();
		}

		const handleMove = (e)=>{
			let committed = false;

			if (this.holdTimer) {
				clearTimeout(this.holdTimer)
				this.holdTimer = null;
			}

			if (this.draggingHandle == "left") {
				
				const startMeasureOfFirstInstrument = this.state.startMeasure[0];
				const startMeasureOfFirstInstrumentY = startMeasureOfFirstInstrument.boundingBox.absolutePosition.y;
				const startMeasureOfFirstInstrumentHeight = startMeasureOfFirstInstrument.boundingBox.boundingRectangle.y + startMeasureOfFirstInstrument.boundingBox.boundingRectangle.height;
				
				const startMeasureOfFirstInstrumentStaffCenterY = startMeasureOfFirstInstrumentY + 0.5 * startMeasureOfFirstInstrumentHeight; // use it instead of the y position directly to create some tolerance to prevent precision issues
				
				this.setPositionByMouseEvent(
					e,
					false,
					true,
					startMeasureOfFirstInstrumentStaffCenterY
				);
			} else if (this.draggingHandle == "right") {
				
				const endMeasureOfFirstInstrument = this.state.endMeasure[0];
				const endMeasureOfFirstInstrumentY = endMeasureOfFirstInstrument.boundingBox.absolutePosition.y;
				const endMeasureOfFirstInstrumentHeight = endMeasureOfFirstInstrument.boundingBox.boundingRectangle.y + endMeasureOfFirstInstrument.boundingBox.boundingRectangle.height;
				
				const endMeasureOfFirstInstrumentStaffCenterY = endMeasureOfFirstInstrumentY + 0.5 * endMeasureOfFirstInstrumentHeight; // use it instead of the y position directly to create some tolerance to prevent precision issues
				
				this.setPositionByMouseEvent(
					e,
					true,
					false,
					endMeasureOfFirstInstrumentStaffCenterY
				);
			}

			if (this.draggingHandle) {
				committed = true;

				const triggerSize = 10;
				const speed = 500;
				const dt = 0.1; // second
				
				if (e.clientY < triggerSize) {
					if (this.scrollInterval == null) {
						this.scrollDirection = "top";
						
						const move = () => {
							// console.log(this.scrollBox.scrollTop, speed * dt);
							// this.scrollBox.scrollTop -= speed * dt;
							this.scrollBox.scrollBy({
								top: -speed * dt,
								left: 0,
								behavior: "smooth",
							});
						}
		
						move();
		
						this.scrollInterval = setInterval(move, dt * 1000);
					}
				} else {
					if (this.scrollDirection == "top") {
						this.clearScrollInterval();
					}
				}


				if (e.clientY >= this.scrollBox.getBoundingClientRect().height - triggerSize) {
					if (this.scrollInterval == null) {
						this.scrollDirection = "bottom";

						const move = () => {
							// console.log("A", this.scrollBox.scrollTop, speed * dt);
							// this.scrollBox.scrollTop += speed * dt;
							this.scrollBox.scrollBy({
								top: speed * dt,
								left: 0,
								behavior: "smooth",
							});
						}
		
						move();
		
						this.scrollInterval = setInterval(move, dt * 1000);
					}
				
				} else {
					if (this.scrollDirection == "bottom") {
						this.clearScrollInterval();
					}
				}
			}

			return committed;
		};

		window.addEventListener("resize", ()=>{
			this.onScoreResized();
		});

		window.addEventListener("keydown", (e)=>{
			// if (e.key == "r") {
				
			// 	this.scrollBox.scrollTop=1;
			// 	console.log(this.scrollBox.scrollTop);
			// }
		});
		
		this.scrollBox.addEventListener("mousedown", (e)=>{
			if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) {
				// ignore mousedown on scrollbars
				return;
			}

			// console.log("mousedown");
			handleDown(e);
		});
		
		window.addEventListener("mouseup", (e)=>{ // must be window, to prevent missing the event outside the scroll box
			// console.log("mouseup");
			handleUp(e);
		});

		this.scrollBox.addEventListener("touchstart", (e)=>{
			// console.log("touchstart");
			const mouseEvent = new MouseEvent("mousedown", {
				screenX: e.changedTouches[0].screenX,
				screenY: e.changedTouches[0].screenY,
				clientX: e.changedTouches[0].clientX,
				clientY: e.changedTouches[0].clientY,
				view: window,
				cancelable: true,
				bubbles: true,
			});

			e.changedTouches[0].target.dispatchEvent(mouseEvent);
					
			// const dummyMouseEvent = {
			// 	clientX: e.changedTouches[0].clientX,
			// 	clientY: e.changedTouches[0].clientY,
			// }

			// handleDown(dummyMouseEvent);
		});

		window.addEventListener("touchend", (e)=>{
			// console.log("touchend");

			// if (e.cancelable) {
			// 	e.preventDefault();
			// }

			const mouseEvent = new MouseEvent("mouseup", {
				screenX: e.changedTouches[0].screenX,
				screenY: e.changedTouches[0].screenY,
				clientX: e.changedTouches[0].clientX,
				clientY: e.changedTouches[0].clientY,
				view: window,
				cancelable: true,
				bubbles: true,
			});
		
			e.changedTouches[0].target.dispatchEvent(mouseEvent);

			// const dummyMouseEvent = {
			// 	clientX: e.changedTouches[0].clientX,
			// 	clientY: e.changedTouches[0].clientY,
			// }

			// handleUp(dummyMouseEvent);
			
		}, {passive: false});

		window.addEventListener("touchmove", (e)=>{
			// console.log("touchmove");

			// const mouseEvent = new MouseEvent("mousemove", {
			// 	screenX: e.changedTouches[0].screenX,
			// 	screenY: e.changedTouches[0].screenY,
			// 	clientX: e.changedTouches[0].clientX,
			// 	clientY: e.changedTouches[0].clientY,
			// 	view: window,
			// 	cancelable: true,
			// 	bubbles: true,
			// });
		
			// e.changedTouches[0].target.dispatchEvent(mouseEvent);

			const dummyMouseEvent = {
				clientX: e.changedTouches[0].clientX,
				clientY: e.changedTouches[0].clientY,
			}
			if (handleMove(dummyMouseEvent)) {
				e.preventDefault();
			}
			
		}, {passive: false});
		
		window.addEventListener("mousemove", (e) => {
			// console.log("mousemove", e);
			handleMove(e);
		});
	}

	onScoreResized() {
		this.updatePositionByTimestamps();
	}
	
	componentDidUpdate() {
	}
	
	render() {
		if (!this.state.visible) {
			return null;
		}
		
		const osmd = this.props.osmd;
		const osmdExtension = this.props.osmdExtension;
		
		const startMeasure = this.state.startMeasure;
		const endMeasure = this.state.endMeasure;

		if (startMeasure == null || endMeasure == null) {
			return;
		}
		
		var startMusicSystemId = startMeasure[0].parentMusicSystem.id;
		var endMusicSystemId = endMeasure[0].parentMusicSystem.id;
		
		var highlights = [];
		
		// console.log(osmdExtension.osmd2ActualPosition(startMeasure[0].parentMusicSystem.boundingBox.boundingRectangle.width))
		
		// Find out all the music systems
		const musicSystems = osmdExtension.findAllMusicSystems();
		
		const highlightLineCount = endMusicSystemId - startMusicSystemId + 1;
		
		for (var i = 0; i < highlightLineCount; i++) {
			const measuresInMusicSystem = musicSystems[i + startMusicSystemId].graphicalMeasures;
			
			// let startPosition = osmdExtension.osmd2ActualPosition(startMeasure[0].boundingBox.absolutePosition.x);
			let startPosition = this.state.startPosition;
			let endPosition = this.state.endPosition;
			
			const [y1, y2] = osmdExtension.getMusicSystemActualPositionY(musicSystems[i + startMusicSystemId]);
			
			// console.log(firstMeasureWithLastInstrumentInTheLine.boundingBox)
			
			if (i > 0) {
				startPosition = osmdExtension.osmd2ActualPosition(
					measuresInMusicSystem[0][0].boundingBox.absolutePosition.x
				);
			}
			
			if (i < highlightLineCount - 1) {
				endPosition = osmdExtension.osmd2ActualPosition(
					measuresInMusicSystem[measuresInMusicSystem.length-1][0].boundingBox.absolutePosition.x +
					measuresInMusicSystem[measuresInMusicSystem.length-1][0].boundingBox.boundingRectangle.x + 
					measuresInMusicSystem[measuresInMusicSystem.length-1][0].boundingBox.boundingRectangle.width
				);
			}

			var highlight = (
			
				<Box key={i} sx = {{
					position: "absolute",
					bgcolor: "rgba(0,130,240,0.1)",
					
					left: startPosition,
					top: y1,
					
					width: endPosition - startPosition + 1,
					height: y2 - y1 + 1,
				}}>
					
				</Box>
			);
			highlights.push(highlight);
		}

					
		const handleWidth = 4;
			
		const createHandleBall = (leftOrRight) => {
			return (
				<Box
					sx = {{
						position: "absolute",
						bgcolor: "rgba(0,130,240)",
						
						left: -8 + 0.5 * handleWidth,
						top: -16,
						
						width: 16,
						height: 16,
						
						borderRadius: "50%",
						
						boxShadow: "0 0 6px rgba(0,0,0,0.4)",
					}}
					
					onMouseDown = {(e) => {
						this.draggingHandle = leftOrRight;
						
						e.preventDefault ? e.preventDefault() : e.returnValue = false; // prevent default HTML drag
					}}
				/>
			)
		};
		
		const createCloseButton = (leftOrRight) => {
			return (<Fab
				sx={{
					position: "absolute",
					bgcolor: "rgba(255,255,255,0.5)",
					bottom: "-40px",
					left: leftOrRight=="left"? "10px" : "unset",
					right: leftOrRight=="right"? "10px" : "unset",
					maxHeight: "30px",
					minHeight: "30px",
					minWidth: "30px",
					maxWidth: "30px",
					// boxShadow: "0 0 6PX rgba(0,0,0,0.5)"
					// boxShadow: "0 0 10px black",
				}}
				onClick={(e)=>{
					this.close();
					e.stopPropagation();
				}}
			>
				<CloseIcon sx={{width: "80%"}} />
			</Fab>);
		};

		var leftHandle = (<Box sx = {{
			position: "absolute",
			bgcolor: "rgba(0,130,240)",
			
			// left: -0.5 * handleWidth,
			// top: 0,
			
			// width: handleWidth,
			// height: "100%",

			left: highlights[0].props.sx.left -0.5 * handleWidth,
			top: highlights[0].props.sx.top,
			
			width: handleWidth,
			height: highlights[0].props.sx.height,
			
			boxShadow: "-2px 0 4px rgba(0,0,0,0.4)",
			
			"::after": {
				bgcolor: "rgba(0,130,240)",
				
				content:"\"\"",
				position: "absolute",
				
				left: 0,
				top: 0,
			
				width: handleWidth,
				height: "100%",
				
			}
		}}>
			{createHandleBall("left")}
			{createCloseButton("left")}
		</Box>);
					
		var rightHandle = (<Box sx = {{
			position: "absolute",
			bgcolor: "rgba(0,130,240)",
			
			// right: -0.5 * handleWidth,
			// top: 0,
			
			// width: handleWidth,
			// height: "100%",

			left: highlights[highlights.length-1].props.sx.left + highlights[highlights.length-1].props.sx.width -0.5 * handleWidth,
			top: highlights[highlights.length-1].props.sx.top,
			
			width: handleWidth,
			height: highlights[highlights.length-1].props.sx.height,
			
			boxShadow: "2px 0 4px rgba(0,0,0,0.4)",
			
			"::after": {
				bgcolor: "rgba(0,130,240)",
				
				content:"\"\"",
				position: "absolute",
				
				left: 0,
				top: 0,
			
				width: handleWidth,
				height: "100%",
				
			}
		}}>
			{createHandleBall("right")}
			{highlightLineCount > 1? createCloseButton("right") : null}
		</Box>);
		
		return (
			<Box id="scoreRangeSelector" sx={{position:"absolute", left:0, top:0, zIndex: 3}}>
				{leftHandle}
				{rightHandle}
				{highlights}
				
			</Box>
		);
	}
};